import React, { Component } from 'react'
import ImgCode from './components/ImgCode'
import SmsCode from './components/SmsCode'
import LoginBtn from './components/LoginBtn'
import { getParams, setCookie, getCookie, getLang, getProtocol, createUrl, postPromise, browser } from '../../common/utils'
import { ONECLOUD_API_HOST } from '../../common/consts'
import t from '../../i18n/login'

const api = {
    checklogin: `${ONECLOUD_API_HOST}/user/checklogin`,
    login: `${ONECLOUD_API_HOST}/user/login`,
    checkImgCode: `${ONECLOUD_API_HOST}/user/smslimitremaining`,
    freshImgCode: `${ONECLOUD_API_HOST}/captcha/refresh`,
    sendsmscode: `${ONECLOUD_API_HOST}/user/sendsmscode`,
}

const SMSCODE_NEED_IMGCODE = -500 // 发送短信验证码受限，需要输入图像验证码

export default class Login extends Component {
    constructor(props) {
        super(props)
        const lang = getLang()
        const rootSite = `${getProtocol()}${location.hostname}`

        this.Timer60s = null
        this.TimerReload = null
        this.config = {
            loginPage: createUrl('html/login'),
            homePage: createUrl('site/index'),
            allowJumpSite: [
                rootSite,
                'http://wanke.xunlei.com',
                'http://wanke.onethingcloud.com'
            ],
            maxTime: 5,
            reloadIntval: 5000,
            count: 0,
            phoneArea: {
                cn: {
                    name: t('cn'),
                    num: '86',
                    phoneLength: 11,
                    reg: /^(13|14|15|16|17|18|19)[\d]{9}$/
                },
                hk: {
                    name: t('hk'),
                    num: '852',
                    phoneLength: 8,
                    reg: /^\d{8}$/
                }
            }
        }
        this.queryParams = {
            isPc: browser('pc') ? true : false,
        }

        this.state = {
            lang,
            checkedArea: lang,
            isSelectAreaOn: false,
            phone: '',
            imgCode: '',
            smsCode: '',
            imgCodeSrc: '',
            isImgLoadingOn: false,
            freeImgCodeTimes: 1, // 免图形验证码次数
            showImgCode: false,
            phoneError: '',
            imgCodeError: '',
            smsCodeError: '',
            showErrorMsg: '',
            checkedProtocal: false,
            protocolTip: '请阅读并同意协议',
            protocolMsg: '',
            // codeCheck: '',
            secs: 0,
            pop: null,
            lock: false,
        }

        this.handleFreshImgCode = this.handleFreshImgCode.bind(this)
        this.handleImgCodeChange = this.handleImgCodeChange.bind(this)
        this.handleSendSmsCode = this.handleSendSmsCode.bind(this)
        this.handleSmsCodeChange = this.handleSmsCodeChange.bind(this)
        this.validSmsCode = this.validSmsCode.bind(this)
        this.validImgCode = this.validImgCode.bind(this)
        this.toLogin = this.toLogin.bind(this)
        this.listenLogin = this.listenLogin.bind(this)
        this.toggleCheckProtocol = this.toggleCheckProtocol.bind(this)
    }

    componentDidMount() {
        // 防止登录后进入登录页，因公用检查顺序在后
        this.checkLoginIfLoginPage()
    }

    componentWillUnmount() {
    	clearInterval(this.Timer60s)
    	clearInterval(this.TimerReload)
    }

    handleSendSmsCode() {
        const { freeImgCodeTimes, showImgCode, lock } = this.state
        if (!this.validPhone() || lock) {
            return
        }
        if (!freeImgCodeTimes && !showImgCode) {
            this.setState({
                showImgCode: true
            }, () => {
                this.loadImgCode()
            })
            return
        }
        if ( !freeImgCodeTimes && !this.validImgCode() ) return

        const { phone, imgCode, checkedArea } = this.state
        // const codeCheck = showImgCode ? t('checking') : ''
        this.setState({
            lock: true,
            // codeCheck,
            smsCode: '',
            imgCodeError: '',
            smsCodeError: '',
        })
        const data = {
            phone,
            phone_area: this.config.phoneArea[checkedArea].num,
            type: 0, // 验证码类型(0-短信, 1-语音)
            imgcode: imgCode
        }

        setCookie('phone', phone) // 后端用到
        $.ajax({
            type: 'POST',
            url: api.sendsmscode,
            data,
            dataType: 'json',
            crossDomain: true,
            xhrFields: { withCredentials: true },
            cache: false,
            ifModified: true,
            success: res => {
                const code = res.iRet
                switch (code) {
                    case 0 :
                        this.setState({
                            // codeCheck: '',
                            freeImgCodeTimes: res.data.limit_remaining,
                            lock: false,
                        })
                        this.startTimer60s()
                        return
                    default:
                        const { showImgCode } = this.state
                        if ( code !== SMSCODE_NEED_IMGCODE ) {
                            showImgCode ? this.showErrorMsg('imgCode', res.sMsg) : this.showErrorMsg('smsCode', res.sMsg)
                        }
                        this.setState({
                            lock: false,
                            // codeCheck: '',
                            showImgCode: true,
                            freeImgCodeTimes: 0
                         })
                        this.loadImgCode()
                }
            },
            error: () => {
                this.showErrorMsg('smsCode', t('err_tryagain'))
                this.loadImgCode()
                this.setState({ lock: false })
            }
        })
    }

    handlePhoneChange(e) {
        const { checkedArea } = this.state
        const val = e.target.value
        const len = this.config.phoneArea[checkedArea].phoneLength
        const phoneLen = val.length
        const phone = phoneLen < len ? val : val.slice(0, len)
		this.setState({
            phone,
			phoneError: ''
        }, ()=> {
            if (phoneLen === len && this.validPhone()) {
                this.checkImgCode()
                this.state.showImgCode && this.loadImgCode()
            }
        })
    }

    handleImgCodeChange(e) {
        const val = e.target.value
        this.setState({
            imgCode: val,
            imgCodeError: '',
            // codeCheck: ''
        })
    }

    handleFreshImgCode() {
        this.setState({
            imgCode: ''
        })
        this.loadImgCode()
    }

    handleSmsCodeChange(e) {
		this.setState({
			smsCode: e.target.value,
			smsCodeError: ''
		})
    }

    toggleCheckProtocol() {
        const { protocolTip } = this.state
        this.setState(prevState => ({
            checkedProtocal: !prevState.checkedProtocal,
            protocolMsg: !prevState.checkedProtocal ? '' : protocolTip
        }))
    }

    checkLoginIfLoginPage() {
        if ( location.href.indexOf(this.config.loginPage) !== -1 ) {
             this.checkLogin()
        }
    }

    checkLogin() {
        const doneCb = res => {
            +res.iRet === 0 && this.loginSuccess(res.data)
        }
        postPromise(api.checklogin).done(doneCb)
    }

    toLogin(e) {
        e.preventDefault()
        let validPass = true
        !this.validPhone() && (validPass = false)
        !this.validSmsCode() && (validPass = false)
        this.state.lang === 'cn' && !this.validProtocol() && (validPass = false)
        if (!validPass) return

        this.setState({lock: true})
        const { phone, smsCode, checkedArea } = this.state
        const data = {
            phone,
            phone_area: this.config.phoneArea[checkedArea].num,
            vcode: smsCode
        }
        $.ajax({
			type: 'POST',
            url: api.login,
			data,
			dataType: 'json',
            crossDomain: true,
            xhrFields: { withCredentials: true },
            cache: false,
            ifModified: true,
			success: (res) => {
                this.setState({ lock: false })
                const pageId = PAGE_ID
                if (res.iRet === 0) {
                    haboStat({
                        pageid: pageId,
                        action: 'login_result',
                        other: {
                            result: 'succ'
                        }
                    })
                    setTimeout(() => { // 留给上报时间
                        const { data } = res
                        // this.setSiteCookies(data)
                        // this.setOtherSiteCookies(data)
                        this.loginSuccess(data)
                    }, 50)
				} else {
                    haboStat({
                        pageid: pageId,
                        action: 'login_result',
                        other: {
                            result: 'fail'
                        }
                    })
                    this.showErrorMsg('smsCode', res.sMsg)
				}
			},
			error: () => {
                haboStat({
                    pageid: PAGE_ID,
                    action: 'login_result',
                    other: {
                        result: 'fail'
                    }
                })
                this.showErrorMsg('smsCode', t('err_tryagain'))
				this.setState({ lock: false })
			}
		})
    }

    checkImgCode() {
        const { phone, checkedArea } = this.state
        const doneCb = res => {
            let success = (data) => {
                const { limit_remaining: freeImgCodeTimes } = data
                const showImgCode = freeImgCodeTimes > 0 ? false : true
                this.setState({
                    freeImgCodeTimes,
                    showImgCode
                }, () => showImgCode && this.loadImgCode())
            }
            res.iRet === 0 && success(res.data)
        }
        const data = {
            phone,
            phone_area: this.config.phoneArea[checkedArea].num
        }
       postPromise(api.checkImgCode, data).done(doneCb)
    }

    loadImgCode() {
        if(!this.validPhone(true)) return

        this.setState({
            isImgLoadingOn: true
        })
        this.getImgCode()
        clearInterval(this.TimerReload)
        this.TimerReload = setInterval(() => {
            if (this.config.count < this.config.maxTime) {
                this.config.count += 1
                this.getImgCode()
            } else {
                clearInterval(this.TimerReload)
                this.showErrorMsg('imgCode', t('err_tryagain'))
            }
        }, this.config.reloadIntval)
    }

    getImgCode() {
        const doneCb = res => {
            let success = (data) => {
                clearInterval(this.TimerReload)
                this.config.count = 0
                this.setState({
                    isImgLoadingOn: false,
                    imgCodeSrc: data.image_base64
                })
            }
            res.iRet === 0 && success(res.data)
        }
        const data = {
            captcha_len: 4
        }
       postPromise(api.freshImgCode, data).done(doneCb)
    }

    startTimer60s() {
		clearInterval(this.Timer60s)
		this.setState({
			secs: 60
		})
		this.Timer60s = setInterval(() => {
			let secs = this.state.secs
			if (secs > 0) {
				secs -= 1
				this.setState({
					secs: secs
				})
			} else {
				clearInterval(this.Timer60s)
				this.setState({
					secs: 0
				})
			}
		}, 1000)
    }

    validPhone() {
        const { checkedArea, phone } = this.state
        const val = $.trim(phone)
        const reg = this.config.phoneArea[checkedArea].reg

        if (!val) {
            this.showErrorMsg('phone', t('input_phone'))
            return false
        }
        else if ( !reg.test(val) ) {
			this.showErrorMsg('phone', t('phone_error'))
            return false
        }
        return true
    }

    validImgCode() {
        const val = $.trim(this.state.imgCode)
        const reg = /^[0-9a-z]{4}$/i
        if (!val) {
            this.showErrorMsg('imgCode', t('input_imgcode'))
            return false
        }
        else if (!reg.test(val)) {
            this.showErrorMsg('imgCode', t('imgcode_error'))
            return false
        }
        return true
    }

    validSmsCode() {
        const val = $.trim(this.state.smsCode)
        if (!val) {
            this.showErrorMsg('smsCode', t('input_msg'))
            return false
        }
        else if ( !(/^\d{6}$/.test(val)) ) {
			this.showErrorMsg('smsCode', t('msg_error'))
            return false
        }
        return true
    }

    validProtocol() {
        const { checkedProtocal, protocolTip } = this.state
        let msg = ''
        let pass = true
        if (!checkedProtocal) {
            pass = false
            msg = protocolTip
        }
        this.setState({
            protocolMsg: msg
        })
        return pass
    }

    showErrorMsg(field, msg) {
        this.setState({ [`${field}Error`]: msg })
	}

    listenLogin(e) {
        if (e.keyCode === 13) {
            this.toLogin(e)
        }
    }

    afterLoginNav() {
		const hidePhone = keepPhoneEnd4(getCookie('phone'))
		try{
			isPc ? loginID.html(hidePhone).attr('href', 'javascript:') : loginId.attr('href', 'javascript:').addClass('on')
			if (isBusinessUser) {
				businessNav.show()
				personalNav.hide()
			} else {
				businessNav.hide()
				personalNav.show()
			}
			afterLoginDom.show()
		}catch(e){}
	}

    /* setSiteCookies(data) {
        // 后台接口写的cookie在.com下，.cn需要js来写
        if (window.LANG === 'cn') {
            var domain = location.host.replace('wky','')
            setCookie('phone', this.state.phone, 32*60, domain); // 32小时
            setCookie('phonearea', this.config.phoneArea, 32*60, domain)
            setCookie(`csrf_token`, data.csrf_token, 32*60, domain)
        }
    } */

    // setOtherSiteCookies(data) {
    //     if (location.host.substr(-4) == '.com' && !sessionStorage.getItem('cnCookieMaker')) {
    //         sessionStorage.setItem('cnCookieMaker', 1)
    //         location.href = `//www.onethingcloud.cn/cookie/maker.html?redirect=${encodeURIComponent(location.href)}&csrftoken=${data.csrf_token}`
    //     }
    // }

    keepPhoneEnd4(phone) {
        return phone ? phone.replace(new RegExp('\\d{' + (phone.length - 4) + '}(\\d{4})'), "***$1") : ""
    }

    loginSuccess(data) {
        const { loginCallback } = this.props
        if (loginCallback && typeof loginCallback === 'function') {
            // this.setLoginNav(data)
            loginCallback()
        } else {
            this.loginJump()
        }
    }

    // setLoginNav(data) { // 登录弹窗情况用
    //     try {
    //         const { isPc } = this.queryParams
    //         const { entStatus } = data
    //         const isBusinessUser = entStatus === 1 || entStatus === 3 ? true : false
    //         const loginId = $('#loginID')
    //         const businessNav = $('.business_js')
    //         const personalNav = $('.personal_js')
    //         const afterLoginDom = $('.after_login_js')
    //         const hidePhone = this.keepPhoneEnd4(getCookie('phone'))

    //         // cn-nav
	// 		isPc ? loginId.html(hidePhone).attr('href', 'javascript:') : loginId.attr('href', 'javascript:').addClass('on')
	// 		if (isBusinessUser) {
	// 			businessNav.show()
	// 			personalNav.hide()
	// 		} else {
	// 			businessNav.hide()
	// 			personalNav.show()
	// 		}
    //         afterLoginDom.show()
    //         // hk
    //     // $('div.nav_show_js').show()
    //     // $('#loginID').html(t('logout')).attr('href', 'javascript:').addClass('logout_js')
    //     // $('#accountID').html(hidePhone).show()
	// 	} catch(e) {
    //         console.log(e)
    //     }
    // }

    loginJump() {
        const homePage = this.config.homePage
        const jumpUrl = decodeURIComponent(getParams('jumpurl') || homePage)
        location.href = this.checkUrlSafe(jumpUrl) ?  jumpUrl : homePage
    }

    checkUrlSafe(url) {
        !Array.prototype.find && this.hackForArrayFind()
        const urlReg = /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
        const pathReg = /^\/([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
        const isAllowSite = this.config.allowJumpSite.find(item => {
            const reg = new RegExp('^(' + item + ')(?=\\/|\\?|$)')
            return reg.test(url) ? true : false
        })
        return  urlReg.test(url) && isAllowSite ? true : pathReg.test(url) ? true : false
    }

    toggleSelectArea() {
        this.setState({ isSelectAreaOn: !this.state.isSelectAreaOn })
    }

    selectArea(area) {
        this.setState({
            checkedArea: area,
            isSelectAreaOn: false,

            // reset
            phone: '',
            imgCode: '',
            imgCodeSrc: '',
            isImgLoadingOn: false,
            smsCode: '',
            phoneError: '',
            imgCodeError: '',
            smsCodeError: '',
            showErrorMsg: '',
            // codeCheck: '',
            secs: 0,
            pop: null,
            lock: false,
        }, () => {
             this.loadImgCode()
         })
    }

    getSelectAreaDom(data) {
        let areaDom = []
        for ( let i in data ) {
            let item = data[i]
             areaDom.push(<dd key={i} onClick={(e) => this.selectArea(i, e)}>{item.name}<span className="oc-abs">+{item.num}</span></dd>)
        }
        return areaDom
    }

    hackForArrayFind() {
        Object.defineProperty(Array.prototype, 'find', {
            value: function(predicate) {
                if (this == null) {
                    throw new TypeError('"this" is null or not defined')
                }
                const o = Object(this)
                const len = o.length >>> 0
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function')
                }
                const thisArg = arguments[1]
                let k = 0
                let kValue
                while (k < len) {
                    kValue = o[k]
                    if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue
                    }
                    k++
                }
                return undefined
            }
        })
    }

    renderPhone() {
        const { phone, phoneError, checkedArea, isSelectAreaOn, secs } = this.state
        const phoneAreaData = this.config.phoneArea
        const selectAreaDom = this.getSelectAreaDom(phoneAreaData)

        return (
            <div className="oc-inp">
                <div className="oc-inpbox oc-inpbox-zone">
                    {
                        secs ? <input className="oc-inptxt" type="text" value={phone} disabled />
                             : <input className="oc-inptxt" type="text" value={phone} placeholder={t('input_phone')} maxLength={this.config.phoneArea[checkedArea].phoneLength} onChange={(e) => this.handlePhoneChange(e)} onBlur={() => this.validPhone()} />
                    }
                    <div className="oc-zonebox" onClick={() => this.toggleSelectArea()}>
                        <p className="oc-zone-txt">+{phoneAreaData[checkedArea].num}</p>
                    </div>
                    <div className="oc-zone-list" style={{display: isSelectAreaOn ? "" : "none"}}>
                        <dl>
                            <dt>{t('please_select')}</dt>
                            { selectAreaDom }
                        </dl>
                    </div>
                </div>
                <p className="oc-err">{phoneError}</p>
            </div>
        )
    }

    renderProtocol() {
        const { checkedProtocal, protocolMsg } = this.state
        return (
            <div className="oc-protocol oc-protocol-log">
                <p><input type="checkbox" checked={checkedProtocal} onClick={this.toggleCheckProtocol} /><label onClick={this.toggleCheckProtocol}>我已阅读并同意 </label><a href={createUrl('site/law')} target="_blank">网站服务协议</a> 和 <a href={createUrl('site/law', {tab: 2})} target="_blank">隐私政策</a></p>
                <p className="oc-err">{protocolMsg}</p>
            </div>
        )
    }

    render() {
        const { buttonName: btnName } = this.props
        const {
            lock,
            showImgCode,
            lang,
            isImgLoadingOn,
            imgCode,
            imgCodeSrc,
            imgCodeError,
            // codeCheck,
            smsCode, smsCodeError, secs,
         } = this.state

        const imgCodeData = {
            isImgLoadingOn,
            imgCode,
            imgCodeSrc,
            imgCodeError,
            // codeCheck,
            onImgCodeChange: this.handleImgCodeChange,
            onImgCodeBlur: this.validImgCode,
            onImgCodeFresh: this.handleFreshImgCode,
         }

         const smsCodeData = {
            smsCode, smsCodeError, secs,
            onSmsCodeChange: this.handleSmsCodeChange,
            onSmsCodeKeyDown: this.listenLogin,
            onSmsCodeBlur: this.validSmsCode,
            onSendSmsCode: this.handleSendSmsCode,
         }

         const loginBtnData = {
            lock,
            btnName,
            onClickLogin: this.toLogin,
         }

        return (
            <div>
                <form className="oc-log-form">
                    <a className="oc-logo2" href="#">{t('wky')}</a>
                    <h3>{t('login_by_phone')}</h3>
                    { this.renderPhone() }
                    { showImgCode && <ImgCode {...imgCodeData} /> }
                    <SmsCode {...smsCodeData} />
                    <LoginBtn {...loginBtnData} />
                    { lang === 'cn' && this.renderProtocol() }
                </form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./js/src/pages/Login/Login.js